module.exports = __webpack_public_path__ + "img/chevron-compact-left.0d9326d8.svg";